<template>
  <v-row no-gutters  style="max-height: 75px;">
    <!-- mobile size avatar and menu -->
    <AvatarIconMenu />
    <v-card-subtitle class="d-flex flex-column text-pwt_black pt-0">
      <span class="font-weight-medium text-h6">
        {{ user.fullName }}
      </span>
      <span>
        {{ user.email }}
      </span>
    </v-card-subtitle>
    <v-spacer />
  </v-row>
</template>

<script lang="ts" setup>
import User from '@/classes/user_classes/user';
import AvatarIconMenu from './AvatarIconMenu.vue';

const { user } = defineProps<{ user: User }>()
</script>
